// N11 Ürün Yükleme penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'inventory.n11Upload';

export const inventoryN11UploadGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'N11 katalogundan ürün nasıl eklenir?'),
  intro: t(`${G}.intro`, 'Bu pencerede N11 katalogunda ürün arar, bulduğunuz ürünü sisteme eklersiniz. Arama için ürün adı ve N11 kategorisi gerekir.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    body: t(`${G}.regions.body`, 'Arama ve sonuçlar'),
    footer: t(`${G}.regions.footer`, 'Temizle / Kapat'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Aranacak ürün adını yazın'),
      text: t(`${G}.s1.text`, '"N11\'de Aranacak Ürün Adı" alanına ürün adını yazın. En az 10 karakter girilmelidir.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Kategoriyi adım adım seçin'),
      text: t(`${G}.s2.text`, 'N11 kategorileri hiyerarşiktir; kategori seçimi zorunludur.'),
      tips: [
        t(`${G}.s2.tip1`, '1. İlk önce ana kategoriler yüklenir.'),
        t(`${G}.s2.tip2`, '2. Bir kategori seçtiğinizde alt kategorileri görünür.'),
        t(`${G}.s2.tip3`, '3. 📁 alt kategorisi olan, 📄 son seviye kategoridir.'),
        t(`${G}.s2.tip4`, '4. Üstteki yol (breadcrumb) ile geri gidebilirsiniz; "🏠 Ana Kategoriler" en başa döner.'),
        t(`${G}.s2.tip5`, 'Kutuya en az 2 karakter yazarak tüm kategorilerde arama yapabilirsiniz.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Kategori durum satırı'),
      text: t(`${G}.s3.text`, 'Arama formunun altındaki küçük satır, kategoriler yüklenirken "Kategoriler yükleniyor..." yazar; yükleme bitince mevcut seviyede kaç kategori olduğunu gösterir.'),
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Arayın ve sisteme ekleyin'),
      text: t(`${G}.s4.text`, '"Ara" düğmesi ürün adı ve kategori tamamlanınca açılır. Sonuç kartlarında ürünü inceleyip "Sisteme Ekle" ile ürün oluşturma penceresini açın.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Temizle ve kapat'),
      text: t(`${G}.s5.text`, '"Temizle" formu ve sonuçları sıfırlar, "Kapat" pencereyi kapatır. Başlıktaki (i) bu rehberi yeniden açar.'),
    },
  ],
});
